import type { IFolderKnowledgeFile } from "@frontend-shared/types";
import { EKnowledgeProcessingStatus } from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";

import { knowledgeApi } from "@/api/services";

export const FOLDER_KNOWLEDGE_FILES_QUERY_KEY = "knowledge-folder-files";

const POLLING_INTERVAL_MS = 3000;

const hasInProgressFiles = (
  files: IFolderKnowledgeFile[] | undefined,
): boolean => {
  if (!files) {
    return false;
  }

  return files.some(
    (file) =>
      file.processingStatus === EKnowledgeProcessingStatus.PENDING ||
      file.processingStatus === EKnowledgeProcessingStatus.PROCESSING,
  );
};

interface IUseGetFolderKnowledgeFilesProps {
  folderUuid: string;
  enabled?: boolean;
}

export const useGetFolderKnowledgeFiles = ({
  folderUuid,
  enabled = true,
}: IUseGetFolderKnowledgeFilesProps) => {
  return useQuery({
    queryKey: [FOLDER_KNOWLEDGE_FILES_QUERY_KEY, folderUuid],
    queryFn: () => knowledgeApi.getFolderFiles(folderUuid),
    enabled: enabled && folderUuid.length > 0,
    // NOTE: Poll while any file is still ingesting so its status flips to
    // completed/failed without a manual refresh (mirrors useGetKnowledgeFiles).
    refetchInterval: (query) =>
      hasInProgressFiles(query.state.data) ? POLLING_INTERVAL_MS : false,
  });
};
